import { render, staticRenderFns } from "./WorkspaceDatasetsBubble.vue?vue&type=template&id=59def0d9&scoped=true"
import script from "./WorkspaceDatasetsBubble.vue?vue&type=script&lang=js"
export * from "./WorkspaceDatasetsBubble.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceDatasetsBubble.vue?vue&type=style&index=0&id=59def0d9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59def0d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59def0d9')) {
      api.createRecord('59def0d9', component.options)
    } else {
      api.reload('59def0d9', component.options)
    }
    module.hot.accept("./WorkspaceDatasetsBubble.vue?vue&type=template&id=59def0d9&scoped=true", function () {
      api.rerender('59def0d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceDatasetsBubble.vue"
export default component.exports